import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import PageShell from './PageShell';

const STORAGE_KEY = 'quantumtrade.preferences';

export default function SettingsPage() {
  const [preferences, setPreferences] = useState({
    theme: 'dark',
    chartType: 'candles',
    chartInterval: '1D',
    landingPage: 'dashboard',
    alerts: true,
  });

  useEffect(() => {
    try {
      const stored = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '{}');
      setPreferences((current) => ({ ...current, ...stored }));
    } catch {}
  }, []);

  const updatePreference = (key, value) => {
    const next = { ...preferences, [key]: value };
    setPreferences(next);
    window.localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
  };

  return (
    <PageShell title="Settings" subtitle="Tune your workspace, chart defaults, and alerts." breadcrumbs={[{ label: 'Home' }, { label: 'Settings' }]} activeTab="settings">
      <div className="settings-grid">
        <section className="dashboard-section">
          <h3>Workspace</h3>
          <div className="settings-row">
            <label>Theme</label>
            <select value={preferences.theme} onChange={(event) => updatePreference('theme', event.target.value)}>
              <option value="dark">Dark</option>
              <option value="light">Light</option>
              <option value="system">System</option>
            </select>
          </div>
          <div className="settings-row">
            <label>Default landing page</label>
            <select value={preferences.landingPage} onChange={(event) => updatePreference('landingPage', event.target.value)}>
              <option value="dashboard">Dashboard</option>
              <option value="orders">Orders</option>
              <option value="watchlists">Watchlists</option>
            </select>
          </div>
        </section>

        <section className="dashboard-section">
          <h3>Chart defaults</h3>
          <div className="settings-row">
            <label>Chart type</label>
            <select value={preferences.chartType} onChange={(event) => updatePreference('chartType', event.target.value)}>
              <option value="candles">Candles</option>
              <option value="line">Line</option>
              <option value="area">Area</option>
            </select>
          </div>
          <div className="settings-row">
            <label>Default interval</label>
            <select value={preferences.chartInterval} onChange={(event) => updatePreference('chartInterval', event.target.value)}>
              <option value="1m">1m</option>
              <option value="5m">5m</option>
              <option value="15m">15m</option>
              <option value="1h">1h</option>
              <option value="1D">1D</option>
            </select>
          </div>
        </section>

        <section className="dashboard-section">
          <h3>Alerts & privacy</h3>
          <div className="settings-row">
            <label>Push alerts</label>
            <input type="checkbox" checked={preferences.alerts} onChange={(event) => updatePreference('alerts', event.target.checked)} />
          </div>
          <div className="settings-row">
            <label>Brokerage status</label>
            <span className="muted">Paper trading mode stays enabled unless a live broker is linked.</span>
          </div>
        </section>
      </div>

      <section className="dashboard-section">
        <h3>Legal & disclosures</h3>
        <div className="link-list">
          <Link to="/legal">Terms</Link>
          <Link to="/legal">Privacy</Link>
          <Link to="/legal">Risk Disclosure</Link>
          <Link to="/legal">Data Disclaimer</Link>
        </div>
      </section>
    </PageShell>
  );
}
